<script>
import { ICONS } from '@components/constant'

export default {
  name: 'BaseIcon',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
      validator(value) {
        return Object.keys(ICONS).includes(value)
      },
    },
    size: {
      type: Number,
      default: 16,
    },
  },
  computed: {
    path() {
      return ICONS[this.name]
    },
  },
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
  >
    <path class="fill-current" :d="path" />
  </svg>
</template>
